const GUEST_SESSION_HEADER = 'X-Guest-Session';
const GUEST_SESSION_SECRET_HEADER = 'X-Guest-Session-Secret';

export const GUEST_SESSION_ERROR_CODES = {
    TABLE_OCCUPIED: 'TABLE_OCCUPIED',
    INVALID_JOIN_CODE: 'INVALID_JOIN_CODE',
};

export const getGuestSessionStorageKey = (restaurantId, tableNumber) =>
    `guestSession_${restaurantId}_${tableNumber || 'no-table'}`;

const parseStoredCredentials = (raw) => {
    if (!raw) {
        return null;
    }

    try {
        const parsed = JSON.parse(raw);

        if (parsed?.sessionId && parsed?.joinCode) {
            return {
                sessionId: parsed.sessionId,
                joinCode: parsed.joinCode,
            };
        }
    } catch {
        // Legacy plain sessionId string — treat as invalid
    }

    return null;
};

export const readStoredGuestCredentials = (restaurantId, tableNumber) => {
    try {
        const raw = localStorage.getItem(getGuestSessionStorageKey(restaurantId, tableNumber));
        return parseStoredCredentials(raw);
    } catch {
        return null;
    }
};

export const writeStoredGuestCredentials = (restaurantId, tableNumber, credentials) => {
    try {
        localStorage.setItem(
            getGuestSessionStorageKey(restaurantId, tableNumber),
            JSON.stringify({
                sessionId: credentials.sessionId,
                joinCode: credentials.joinCode,
            })
        );
    } catch {
        // ignore storage errors
    }
};

export const clearStoredGuestCredentials = (restaurantId, tableNumber) => {
    try {
        localStorage.removeItem(getGuestSessionStorageKey(restaurantId, tableNumber));
    } catch {
        // ignore storage errors
    }
};

/** @deprecated use readStoredGuestCredentials */
export const readStoredGuestSessionId = (restaurantId, tableNumber) => {
    const credentials = readStoredGuestCredentials(restaurantId, tableNumber);
    return credentials?.sessionId || null;
};

/** @deprecated use writeStoredGuestCredentials */
export const writeStoredGuestSessionId = (restaurantId, tableNumber, sessionId) => {
    if (!sessionId) return;
    const existing = readStoredGuestCredentials(restaurantId, tableNumber);
    if (existing?.joinCode) {
        writeStoredGuestCredentials(restaurantId, tableNumber, {
            sessionId,
            joinCode: existing.joinCode,
        });
    }
};

/** @deprecated use clearStoredGuestCredentials */
export const clearStoredGuestSessionId = (restaurantId, tableNumber) => {
    clearStoredGuestCredentials(restaurantId, tableNumber);
};

export { GUEST_SESSION_HEADER, GUEST_SESSION_SECRET_HEADER };
